import React, { useEffect } from 'react'
import { useFetch } from 'hooks/useFetch'
import SectionError from 'components/error/SectionError'
import Loader from 'components/loader/Loader'

const T = {
  bg:   '#F6F5F0',
  card: '#FFFFFF',
  line: '#E5E2D8',
  ink:  '#232821',
  mut:  '#6E766C',
};

const BrandContainer = (props) => {
  const { url, title } = props
  const { data: rawData, loading, error, retry } = useFetch(url)
  // API returns { success, result } shape
  const data = (rawData && rawData.result) ? rawData.result : []

  return (
    <div style={{
      background: T.card,
      borderRadius: 16,
      border: `1px solid ${T.line}`,
      padding: '18px 20px',
      boxSizing: 'border-box',
      height: '100%',
      maxHeight: 275,
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
    }}>
      <div style={{
        fontFamily: "'Bricolage Grotesque', sans-serif",
        fontSize: 16,
        fontWeight: 700,
        color: T.ink,
        marginBottom: 14,
      }}>
        {title}
      </div>

      {loading ? (
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Loader />
        </div>
      ) : error ? (
        <SectionError message={error.message} onRetry={retry} />
      ) : data.length ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {data.map((item, index) => (
            <span key={index} style={{
              padding: '6px 14px',
              borderRadius: 999,
              border: `1px solid ${T.line}`,
              background: T.bg,
              fontSize: 12,
              fontWeight: 600,
              color: T.ink,
              cursor: 'default',
            }}>
              {item.brand}
            </span>
          ))}
        </div>
      ) : (
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.mut, fontSize: 13 }}>
          Data not available
        </div>
      )}
    </div>
  )
}

export default BrandContainer
